var _a;
import { IdLoca } from "../../utils/i18n/IdLoca";
import { IdTutorialFocusElement } from "./IdTutorialFocusElement";
import { IdTutorialStep } from "./IdTutorialStep";
export var ArrowAnimationName;
(function (ArrowAnimationName) {
    ArrowAnimationName["ANIMATE_LEFT"] = "bouncing-arrow-bounce__left";
    ArrowAnimationName["ANIMATE_RIGHT"] = "bouncing-arrow-bounce__right";
})(ArrowAnimationName || (ArrowAnimationName = {}));
export var TutorialConfig = (_a = {},
    _a[IdTutorialStep.checkNewQuest_clickQuestMenu] = {
        arrowAnimation: ArrowAnimationName.ANIMATE_RIGHT,
        descriptionTopPosition: 15,
        focusId: IdTutorialFocusElement.hud_quest_7,
        hideBackground: true,
        hideHud: false,
        idLocaDescription: IdLoca.tutorial_checkNewQuest1,
        nextStep: IdTutorialStep.checkNewQuest_clickShowMeButton,
    },
    _a[IdTutorialStep.checkNewQuest_clickShowMeButton] = {
        arrowAnimation: ArrowAnimationName.ANIMATE_RIGHT,
        focusId: IdTutorialFocusElement.quest_show_me,
        hideBackground: true,
        hideHud: false,
        nextStep: IdTutorialStep.checkNewQuest_clickStartProduction,
    },
    _a[IdTutorialStep.checkNewQuest_clickStartProduction] = {
        arrowAnimation: ArrowAnimationName.ANIMATE_RIGHT,
        buildingId: 9,
        descriptionTopPosition: 25,
        focusId: IdTutorialFocusElement.button_start_production,
        hideBackground: true,
        hideHud: false,
        idLocaDescription: IdLoca.tutorial_feedChicken,
        nextStep: IdTutorialStep.collectQuestReward_clickQuestMenu,
    },
    _a[IdTutorialStep.collectQuestReward_clickCollectRewards] = {
        arrowAnimation: ArrowAnimationName.ANIMATE_RIGHT,
        focusId: IdTutorialFocusElement.quest_collect,
        hideBackground: true,
        hideHud: false,
        nextStep: IdTutorialStep.levelUpScreen,
        questId: 7,
    },
    _a[IdTutorialStep.levelUpScreen] = {
        arrowAnimation: ArrowAnimationName.ANIMATE_RIGHT,
        hideBackground: false,
        hideHud: false,
        isEmpty: true,
        nextStep: IdTutorialStep.tutorialCompleteConfirmation,
    },
    _a[IdTutorialStep.collectQuestReward_clickQuestMenu] = {
        arrowAnimation: ArrowAnimationName.ANIMATE_RIGHT,
        descriptionTopPosition: 60,
        focusId: IdTutorialFocusElement.hud_quest_7,
        hideBackground: true,
        hideHud: false,
        idLocaDescription: IdLoca.tutorial_collectQuestReward1,
        nextStep: IdTutorialStep.collectQuestReward_clickCollectRewards,
    },
    _a[IdTutorialStep.confirmConstruction] = {
        arrowAnimation: ArrowAnimationName.ANIMATE_RIGHT,
        buildingId: 8,
        descriptionTopPosition: 10,
        hideBackground: true,
        hideHud: false,
        idLocaDescription: IdLoca.tutorial_constructWindmill6,
        nextStep: IdTutorialStep.produceChickenFeed_clickWindmill,
    },
    _a[IdTutorialStep.constructWindmill_constructionProgress] = {
        arrowAnimation: ArrowAnimationName.ANIMATE_RIGHT,
        buildingId: 8,
        descriptionTopPosition: 75,
        hideArrow: true,
        hideBackground: true,
        hideHud: false,
        idLocaDescription: IdLoca.tutorial_constructWindmill5,
        nextStep: IdTutorialStep.confirmConstruction,
    },
    _a[IdTutorialStep.constructWindmill_clickBuildMenu] = {
        arrowAnimation: ArrowAnimationName.ANIMATE_RIGHT,
        buildingId: 8,
        descriptionTopPosition: 55,
        focusId: IdTutorialFocusElement.button_building_menu,
        hideBackground: false,
        hideHud: false,
        idLocaDescription: IdLoca.tutorial_constructWindmill1,
        nextStep: IdTutorialStep.constructWindmill_clickBuyButton,
    },
    _a[IdTutorialStep.constructWindmill_clickBuyButton] = {
        arrowAnimation: ArrowAnimationName.ANIMATE_LEFT,
        buildingId: 7,
        descriptionTopPosition: 40,
        focusId: IdTutorialFocusElement.button_building_buy,
        hideBackground: false,
        hideHud: true,
        idLocaDescription: IdLoca.tutorial_constructWindmill3,
        nextStep: IdTutorialStep.constructWindmill_confirmPlacement,
    },
    _a[IdTutorialStep.constructWindmill_confirmPlacement] = {
        arrowAnimation: ArrowAnimationName.ANIMATE_RIGHT,
        buildingId: 7,
        descriptionTopPosition: 10,
        focusId: IdTutorialFocusElement.button_building_placement,
        hideArrow: false,
        hideBackground: false,
        hideHud: false,
        idLocaDescription: IdLoca.tutorial_constructWindmill4,
        nextStep: IdTutorialStep.constructWindmill_constructionProgress,
    },
    _a[IdTutorialStep.harvestCorn_clickAcre] = {
        arrowAnimation: ArrowAnimationName.ANIMATE_RIGHT,
        buildingId: 7,
        descriptionTopPosition: 75,
        hideBackground: false,
        hideHud: true,
        idLocaDescription: IdLoca.tutorial_harvestCorn,
        nextStep: IdTutorialStep.sowWildflowers_clickAcre,
    },
    _a[IdTutorialStep.harvestWildflowers_clickAcre] = {
        arrowAnimation: ArrowAnimationName.ANIMATE_RIGHT,
        buildingId: 7,
        descriptionTopPosition: 60,
        hideBackground: true,
        hideHud: false,
        idLocaDescription: IdLoca.tutorial_harvestWildflowers,
        nextStep: IdTutorialStep.checkNewQuest_clickQuestMenu,
    },
    _a[IdTutorialStep.produceChickenFeed_clickStartProduction] = {
        arrowAnimation: ArrowAnimationName.ANIMATE_RIGHT,
        buildingId: 8,
        descriptionTopPosition: 25,
        focusId: IdTutorialFocusElement.button_start_production,
        hideBackground: false,
        hideHud: false,
        idLocaDescription: IdLoca.tutorial_produceChickenFeed2,
        nextStep: IdTutorialStep.harvestWildflowers_clickAcre,
    },
    _a[IdTutorialStep.produceChickenFeed_clickWindmill] = {
        arrowAnimation: ArrowAnimationName.ANIMATE_RIGHT,
        buildingId: 8,
        descriptionTopPosition: 65,
        hideBackground: true,
        hideHud: false,
        idLocaDescription: IdLoca.tutorial_produceChickenFeed1,
        nextStep: IdTutorialStep.produceChickenFeed_clickStartProduction,
    },
    _a[IdTutorialStep.sowWildflowers_clickAcre] = {
        arrowAnimation: ArrowAnimationName.ANIMATE_RIGHT,
        buildingId: 7,
        descriptionTopPosition: 10,
        hideBackground: false,
        hideHud: true,
        idLocaDescription: IdLoca.tutorial_sowWildflowers1,
        nextStep: IdTutorialStep.sowWildflowers_clickOnRecipe,
        recipeId: 11,
    },
    _a[IdTutorialStep.sowWildflowers_clickOnRecipe] = {
        arrowAnimation: ArrowAnimationName.ANIMATE_RIGHT,
        buildingId: 7,
        descriptionTopPosition: 35,
        focusId: IdTutorialFocusElement.recipe_1,
        hideBackground: false,
        hideHud: true,
        idLocaDescription: IdLoca.tutorial_sowWildflowers3,
        nextStep: IdTutorialStep.sowWildflowers_clickStartProduction,
    },
    _a[IdTutorialStep.sowWildflowers_clickStartProduction] = {
        arrowAnimation: ArrowAnimationName.ANIMATE_RIGHT,
        buildingId: 7,
        descriptionTopPosition: 35,
        focusId: IdTutorialFocusElement.button_start_production,
        hideBackground: false,
        hideHud: true,
        idLocaDescription: IdLoca.tutorial_sowWildflowers4,
        nextStep: IdTutorialStep.constructWindmill_clickBuildMenu,
        recipeId: 1,
    },
    _a[IdTutorialStep.tutorialCompleteConfirmation] = {
        arrowAnimation: ArrowAnimationName.ANIMATE_RIGHT,
        hideBackground: true,
        hideHud: false,
        idLocaDescription: IdLoca.tutorial_finished,
        nextStep: undefined,
    },
    _a[IdTutorialStep.welcome_clickConfirmButton] = {
        arrowAnimation: ArrowAnimationName.ANIMATE_RIGHT,
        buildingId: 7,
        hideBackground: false,
        hideHud: true,
        idLocaDescription: IdLoca.tutorial_welcome,
        nextStep: IdTutorialStep.harvestCorn_clickAcre,
    },
    _a);



//////////////////
// WEBPACK FOOTER
// ./src/features/tutorial/TutorialConfig.ts
// module id = 478
// module chunks = 3